<template>
    <div class="ganz-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">
                <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                        style="background: url('/assets/images/homepage_pexels-andrea-piacquadio-3763871_1250x835.jpg')  center;">
                        <h4 class="widget-user-desc text-left heading-border">Playing the Game to Win.</h4>
<h4 class="widget-user-desc text-left heading-border">Me: Version 2.0</h4>
                        <h4 class="widget-user-desc text-right heading-border">Empowered. Independent.</h4>
                        <h4 class="widget-user-desc text-right heading-border">Fearless. Fun.</h4>
                    </div>
                    <div class="widget-user-image">
                        <img class="img-circle" src="/assets/images/homepage_pexels-koolshooters_128x128.jpg" alt="User Avatar">
                    </div>
                </div>
            </div>
        </div>


        <div class="card text-center bg-secondary mt-2" style="font-size: x-small;">
 <div style="text-align:right !important;font-size:xx-small;"><a @click="showVideoModal('mels_video')" class="btn btn-sm col-2">
        <i class="fas fa-tv fai-yellow"></i> Msg from Founder</a></div>
            Life is a Game;  A game we all want to win: Big-Time.<br/>
            Each one of us wants Better: "Version 2.0 of Me" in our Older years:
            <br/><span style="font-size: larger;color:orange;">Physically Powerful, Empowered, Capable, Independent, Fearless, Feisty &amp; Fun.</span>
            <h3  style="font-size:larger;font-weight: bold;" >Get into the Game with all of your heart.  <u>Play to Win</u>. </h3>
            <span style="color:orange;"><i>(Use the information &amp; tools in here: They help put you high above the You that you'd have otherwise been.)</i></span>
            <h1 class="heading-border" style="font-size:x-larger;font-weight: bold;" >Welcome to 'The Future of Ageing'! </h1>
        </div>

        <div class="row mt-2 col-lg-12 col-12"  v-if="rewatchVideoRequested">
            <!-- <button class="btn btn-sm btn-warning align-right mx-2" @click="displayQSVideo=true">Display QuickStart Video</button> -->
            <div class="col-lg-12 col-12 d-flex justify-content-end"> <!-- Add a div with flex utilities -->
                <button class="btn btn-sm btn-warning mb-2" @click="displayQSVideo=true">Display QuickStart Video</button>
            </div>
        </div>

        <div id="newStarterWorkflow" class="row mt-2">
            <div class="col-lg-8 col-8 mx-auto"
                    v-if="!userprefsData || !this.userprefsData.agreedterms_cond">
                <div class="small-box bg-warning card d-flex flex-row justify-content-center">
                    <h4 class="p-2" >STEP 1:<span >Disclaimer and </span>User Preferences:</h4>
                </div>
               <div class="card row text-center" v-if="disclaimer">
                    <div v-if="!userprefsData || !this.userprefsData.agreedterms_cond" class="col" style="padding:.5em;">

                        <h2 class="m-2" >Disclaimer</h2>
                        <p v-html="disclaimerText" style="text-align:left;"></p>
                    </div>
                    <div  class="card row text-center">
                        <div class="small-box bg-primary card d-flex flex-row justify-content-center">
                                                <h5 class>Please <span v-html="userprefsData?'update':'enter'"></span> your preferences<span  v-if="!userprefsData || !this.userprefsData.agreedterms_cond"><br/> and signify acceptance of the above disclaimer</span>:</h5>
                        </div>
                        <div class="row flex-row d-flex justify-content-between">
                            <div class="card row p-2 mx-auto">
                                <div class="p-2">
                                    <small>Days per Week Available for Workout: </small>
                                    <input style="width:3em;"  v-model="prefs_daysavailable" type="number" min="3" max="5">
                                </div>
                                <div class="p-2">
                                    <span><b>Exercise Type:</b></span>
                                    <select style="width:13em;"  v-model="prefs_exercisetype" >
                                        <option name="bodywtonly" value="bodywttrue">Body-Weight Only</option>
                                            <option name="gymwt" value="bodywtfalse">(Gym) Weights &amp; Machines</option>
                                    </select>
                                </div>
                                <div  v-if="!userprefsData || !this.userprefsData.agreedterms_cond" class="p-2">
                                    <span>I accept the above disclaimer</span>:<input style="width:2em;" :checked="disclaimer_tick" v-model="disclaimer_tick" type="checkbox">
                                </div>
                                <div class="p-2  justify-content-between">
                                    <button :disabled="savePrefsButtonDisable()" class="btn btn-sm btn-success m-2 p-2" @click="savePrefs" >Save my Preferences</button>
                                    <span v-if="!userprefsData || !this.userprefsData.agreedterms_cond"><button class="btn btn-sm btn-warning m-2 p-2" @click="notNow" >Not Now</button></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-10 col-10 mx-auto"  v-else-if="qsVideoSrc && !viewedQSVideo">
                <h4 style="font-weight:bold;">STEP 2: Please watch the below Newbie QuickStart video:</h4>
                <span style="color:orange;">(Click on the Video to Start/Stop it as needed.)</span>
                <div v-if="getVideoSource(qsVideoSrc)=='OTHER'" class="video-container embed-responsive embed-responsive-16by9">
                    <video  width="560" height="315" id="vid1" ref="videoPlayer" @click="handleVideoClick('vid1')" @timeupdate="handleTimeUpdate" autoplay="autoplay">
                        <source :src="qsVideoSrc" type="video/mp4">
                        <!-- <img style="height:20px;width:20px;" src="images/run_video_icon.png" alt="Arrow Image" class="arrow-image"> -->
                    </video>
                    <img v-if="isPausedStopped" @click="handleVideoClick('vid1')" src="images/run_video_icon.png" alt="Arrow Image" class="arrow-image">
                </div>
                <div v-else-if="getVideoSource(qsVideoSrc)=='YOUTUBE'|| getVideoSource(qsVideoSrc)=='VIMEO'" class="embed-responsive embed-responsive-16by9">
                    <iframe id="ytvimeoplayer" :src="qsVideoSrc"
                            width="560" height="315"
                            frameborder="0"
                            allow="autoplay; fullscreen" allowfullscreen controls='0' modestbranding rel="0"> <!-- width="640" height="564" -->
                    </iframe>
                </div>

            </div>
            <div class="card col-lg-10 col-10 mx-auto">
                <div v-if="!myFSDetails">STEP 3: <a class="btn btn-primary btn-sm m-2" href="/fself">Setup your Future Self (Vision and Strategy)</a></div>
                <div v-if="fsLettersData.length <1">STEP 4: <a class="btn btn-primary btn-sm m-2" href="/comms/letters">Write a Letter to/from your Future Self</a></div>
            </div>

            <div class="card col-lg-10 col-10 mx-auto">
                <div v-if="!userprefsData || !userprefsData.prefs_exercisetype==''  || !userprefsData.numdaysavailable">STEP 5A:
                    <a class="btn btn-primary btn-sm m-2" href="/workout/myprefs">Setup your Workout Preferences</a>
                </div>
                <div class="col-lg-10 col-10 "  v-else>
                STEP 5B: Please watch the below videos:
                <div class="d-flex justify-content-between" v-for="(vid, index) in phyVideos" :key="index">
                        <a  @click="showVideoModal(vid.page_element_id)" class="btn btn-sm btn-primary m-2 col-sm-8">{{vid.title}}</a>
                </div>
            </div>

            </div>
            <div class="card col-lg-10 col-10 mx-auto">
                <div v-if="timeSlicesData.length <1" >STEP 6: <a class="btn btn-primary btn-sm m-2" href="/showofforum">Setup your First TimeSlice</a></div>
            </div>
            <div class="card col-lg-10 col-10 mx-auto">
                <div>Note: if a numbered STEP is missing, you've done it!</div>
            </div>
        </div>

        <div id="rewatchVideoElement" class="card row col-lg-10 col-10 mt-2 mx-auto"  v-if="displayQSVideo">
                <div class="col-lg-12 col-12 d-flex justify-content-end">
                <button type="button" @click="cancelRewatchVideo" class="close" title="Close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button></div>
            <h4 style="font-weight:bold;">Newbie QuickStart video:</h4>
            <span style="color:orange;">(Click on the Video to Start/Stop it as needed.)</span>
            <!-- <div class="video-container embed-responsive embed-responsive-16by9">
                <video  width="560" height="315" id="vid2" ref="videoPlayer2" @click="handleVideoClick('vid2')" autoplay="autoplay">
                    <source :src="qsVideoSrc" type="video/mp4">
                </video>
                <img v-if="isPausedStopped" @click="handleVideoClick('vid2')" src="images/run_video_icon.png" alt="Arrow Image" class="arrow-image">
            </div> -->
                <div v-if="getVideoSource(qsVideoSrc)=='OTHER'" class="video-container embed-responsive embed-responsive-16by9">
                    <video  width="560" height="315" id="vid2" ref="videoPlayer2" @click="handleVideoClick('vid1')" @timeupdate="handleTimeUpdate" autoplay="autoplay">
                        <source :src="qsVideoSrc" type="video/mp4">
                        <!-- <img style="height:20px;width:20px;" src="images/run_video_icon.png" alt="Arrow Image" class="arrow-image"> -->
                    </video>
                    <img v-if="isPausedStopped" @click="handleVideoClick('vid1')" src="images/run_video_icon.png" alt="Arrow Image" class="arrow-image">
                </div>
                <div v-else-if="getVideoSource(qsVideoSrc)=='YOUTUBE'|| getVideoSource(qsVideoSrc)=='VIMEO'" class="embed-responsive embed-responsive-16by9">
                    <iframe id="ytvimeoplayer" :src="qsVideoSrc"
                            width="560" height="315"
                            frameborder="0"
                            allow="autoplay; fullscreen" allowfullscreen controls='0' modestbranding rel="0"> <!-- width="640" height="564" -->
                    </iframe>
                </div>
        </div>

         <div id="celebrationSection" class="row mt-2">
            <celebration :userdata="userinfo" :reason="celebrationReason"></celebration>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import EventBus from '../../event-bus';
import prizes from '../rewards/Rewards.vue';
import celebration from '../rewards/Celebration.vue';

export default {
    components: {
        prizes,
        celebration,

     },
    name: "NewStarterChecklist",
    data() {
        return {
            thisComponentName: '',
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            userinfo:'',
            userprefsData:[],
            newstarterreqsData:[],
            numdaysavailable:'',
            disclaimerText:'',
            prefs_daysavailable:'',
            disclaimer_tick:'',
            disclaimerAccepted:'',
            prefs_exercisetype:'',
            myFSDetails:'',
            videos:'',
            viewedQSVideo:false,
            rewatchVideoRequested: false,
            displayQSVideo:false,
            doneTimeSlice:false,
            video_duration:53,
            qsVideoSrc:'',
            isPausedStopped: true,
            videoIsPausedStopped: {},
            timeSlicesData:[],
            fsLettersData:[],
            celebrationReason:'',
            founderVideo:'',
            founderVideoSrc:'',
            founderVideoDuration:'',
            phyVideos:[],
            siteVideos:[],
        }
    },

    props: {
        userdata:'',
        disclaimer:'',
        userprefs:'',
        disclaimer_acceptedx:'',
        disclaimeraccepted:'',
        myfsdetails:'',
        videolinks: '',
        newstarterreqs:'',
        timeslices: '',
        fsletters:'',
    },
    mounted() {
        this.thisComponentName = this.$options.name;
        this.userinfo = JSON.parse(this.userdata);
        this.disclaimerText = JSON.parse(this.disclaimer);
        this.userprefsData = JSON.parse(this.userprefs);
        this.myFSDetails = JSON.parse(this.myfsdetails);
        this.videos = JSON.parse(this.videolinks);
        this.siteVideos = [{'name': 'MelsPersonalMessage_video', 'page_element_id':'mels_video', 'title':'', 'duration':0, 'src':''},
                {'name': this.thisComponentName + "_video", 'page_element_id':'qs_video', 'title':'', 'duration':0, 'src':''},
                {'name': 'Newbie_LegStrength_video', 'page_element_id':'phy_lowerbody_video', 'title':'', 'duration':0, 'src':''},
                {'name': 'Newbie_UpperBodyStrength_video', 'page_element_id':'phy_upperbody_video', 'title':'', 'duration':0, 'src':''},
                {'name': 'Newbie_Nutrition_video', 'page_element_id':'phy_nutr_video', 'title':'', 'duration':0, 'src':''}];

        this.setupThisPageVideos();
        this.disclaimerAccepted = JSON.parse(this.disclaimeraccepted);
        this.newStarterReqs = JSON.parse(this.newstarterreqs);

        if(this.newStarterReqs) {
            this.viewedQSVideo = this.newStarterReqs.startervideoviewed;
            this.rewatchVideoRequested = this.newStarterReqs.qsvideorewatch;

            if(!this.viewedQSVideo || this.rewatchVideoRequested) {
                this.trackYTVideoPlayStatus();
            }
        }
        this.timeSlicesData = JSON.parse(this.timeslices);
        if(this.timeSlicesData.length >1){
            this.doneTimeSlice = true;
        }
        this.fsLettersData = JSON.parse(this.fsletters);
        this.checkShowStarterSection();

        // this.handleVideoClick();
         if(this.userprefsData && this.userprefsData.agreedterms_cond !=null) this.disclaimer_tick = this.userprefsData.agreedterms_cond;
        if(this.userprefsData &&(this.userprefsData.agreedterms_cond != null && this.userprefsData.prefs_daysavailable >=3)) window.location('/workout/myworkout');



    },

    methods: {
        trackYTVideoPlayStatus() {
            var player = new YT.Player('ytvimeoplayer', {
                events: {
                    'onReady': onPlayerReadyYT,
                    'onStateChange': onPlayerStateChangeYT
                }
            });
        },
        onPlayerReadyYT(event) {
                // Video is ready to be played
                event.target.playVideo();
        },
        onPlayerStateChangeYT(event) {
            if (event.data == YT.PlayerState.PLAYING) {
                // Video is playing
                var duration = player.getDuration();
                setInterval(function() {
                    var currentTime = player.getCurrentTime();
                    var percentageWatched = (currentTime / duration) * 100;

                    // Check if video has been fully watched (assume 95% or more)
                    if (percentageWatched >= 90) {
                        // Video has been fully watched
                        console.log('Video fully watched!');
                        // Add your code to perform actions when video is fully watched
                        this.doubleConfirmOnVideoViewed('');
                    }
                }, 1000); // Check every second
            }
        },
        getVideoSource(url) {
            //returns 'VIMEO', 'YOUTUBE', 'OTHER'
            if(url.includes('youtube')||url.includes('youtu.be')) return 'YOUTUBE';
            if(url.includes('vimeo')) return 'VIMEO';
            return 'OTHER';
        },

        cancelRewatchVideo() {
            this. handleVideoClick('vid2');
            document.getElementById('rewatchVideoElement').hidden = true;
        },
        setupVideo() {
            const vidObj = this.getVideoObj('qs_video');
            this.video = vidObj;
            this.qsVideoSrc = vidObj.src;
            this.video_duration = vidObj.duration;
        },
        getVideoObj(element_id) {
           var vidObj = '';
            this.siteVideos.forEach(vid => {
                if(vid.page_element_id == element_id) {
                    vidObj = vid;
                };
            });
            console.error(vidObj);
            return vidObj;

        },
        showVideoModal(element_id){
            const vidObj = this.getVideoObj(element_id);
            const payload = {title:vidObj.title,
                            videourl: vidObj.src,
                            displayText: '<div>&nbsp;</div>'
                            };
            EventBus.$emit('displayVideoModal', payload);
        },
        setupThisPageVideos() {
            var vidObjArr = [];
            this.siteVideos.forEach(obj => {
                this.videos.forEach(video => {
                    if(video.name == obj.name) {
                        obj.src = video.url;
                        obj.duration = video.duration;
                        obj.title = video.title;
                        vidObjArr.push(obj);
                        if(obj.page_element_id.startsWith('phy')) {
                            this.phyVideos.push(obj);
                        }
                    }
                });
            });
            this.siteVideos = vidObjArr;
            this.setupVideo();
        },

        checkShowStarterSection() {
            if ( this.viewedQSVideo  && this.timeSlicesData && this.disclaimerAccepted && this.myFSDetails
                && (this.userprefsData && this.userprefsData.agreedterms_cond != null)
                && (this.userprefsData && this.userprefsData.prefs_exercisetype != ''
                && this.userprefsData.numdaysavailable > 0)
                && (this.timeSlicesData.length > 0)
                && (this.fsLettersData.length > 0)) {
                document.getElementById('newStarterWorkflow').hidden = true;
                document.getElementById('celebrationSection').hidden = false;
                this.celebrationReason = "Yippee!! You've completed your New-Starter requirements!";
            } else {
                document.getElementById('newStarterWorkflow').hidden = false;
                document.getElementById('celebrationSection').hidden = true;
            }
        },
        handleVideoClick(vidRef) {
            // console.log("handleVideoClick: " + vidRef);
            //https://stackoverflow.com/questions/14161516/html5-video-completely-hide-controls
            //For Firefox we have to handle it in JavaScript
            //https://douglasgreen.com/demo/responsive-video-play-button/
        var vid =document.getElementById(vidRef);
        if (vid.paused) {
                vid.play();
                this.isPausedStopped = false;
            } else {
                vid.pause();
                this.isPausedStopped = true;
            }
        },
        handleTimeUpdate() {
            const currentTime = this.$refs.videoPlayer.currentTime;
            console.log(currentTime);
            const videoEnd = this.video_duration;
            if (currentTime >= videoEnd) {
                this.viewedQSVideo = true;
                this.doubleConfirmOnVideoViewed();
            }
        },
        recordQSVideoViewed(rewatchNotNeeded){
            console.log("New Starter Video rewatch not needed: " + rewatchNotNeeded);
              axios.post('/user/actions/saveupdate', {
                user_id:this.userinfo.id,
                qsvideowatched:this.viewedQSVideo,
                qsvideorewatch: !rewatchNotNeeded,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
               this.newstarterreqsData =JSON.parse(res.data.newstarterreqs);
                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
               location.reload();
                // this.updateToast(this.message, 4000);
                // this.doubleConfirmOnVideoViewed(this.message) ;
                this.message = '';
            });

        },
        savePrefsButtonDisable() {
            if(this.userprefsData == null) return !(this.disclaimer_tick && this.prefs_daysavailable>0);
            if(this.userprefsData != null) return !(this.prefs_daysavailable && this.prefs_exercisetype);
        },
        showCert() {
            console.log("Clicked ShowCert...");
            document.getElementById('pers_cert').hidden = !document.getElementById('pers_cert').hidden;
        },
        initPerfArray(){
            this.myFSDetails.map((myd) => { this.perf[myd.life_area] = 0;});
        },
        notNow() {
            this.doubleConfirmSwal("We can't provide you with workout systems, until your preferences and disclaimer acceptance are signified.");
        },
        savePrefs() {
            this.userprefsData? this.userprefsData.agreedterms_cond = this.disclaimer_tick:'';
            var agreedtos = this.userprefsData? this.userprefsData.agreedterms_cond:(this.disclaimer_tick? Date.now(): null);
            console.log("Saving prefs.TOS: " .agreedtos);

            axios.post('/user/prefs/save', {
                user_id:this.userinfo.id,
                numdaysavailable:this.prefs_daysavailable,
                agreedterms_cond: agreedtos,
                exercise_type: this.prefs_exercisetype,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
               this.userprefsData =JSON.parse(res.data.userprefs);
                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
                //location.reload();
                // this.updateToast(this.message, 4000);
                this.doubleConfirmOnSavePrefs(this.message) ;
                this.message = '';
            });
        },

        doubleConfirmSwal(message) {
            Swal.fire({
            title:message,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Skip for now',
            denyButtonText: `Let me check it out again`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    Swal.fire('Skipping....', '', 'success');
                    console.log("Skipping UserPrefs for user: " + this.userinfo.id );
                //transfer to SMS home.  TODO
                } else if (result.isDenied) {
                    // Swal.fire('Please review the disclaimer and submit your preferences', '', 'info')

                }
            });
        },

        doubleConfirmOnSavePrefs(message) {
            Swal.fire({
            title:message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'Thanks, got it.',
            denyButtonText: `Let me check it out again`,
            }).then((result) => {
                if (result.isConfirmed) {
                    // Swal.fire('Please progress with your Induction workflow', '', 'success');
                    window.location.reload();
                }
            });
        },

        doubleConfirmOnVideoViewed(message) {
            Swal.fire({
            title:"We will hide this video from you as you've watched it",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Thanks, yes, I'm done with it.",
            denyButtonText: `No, please let me view it again!`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    Swal.fire("We will hide this video from you as you've watched it.", '', 'success');
                    this.recordQSVideoViewed(true);//true=don't provide a link in future
                    // console.log("Skipping UserPrefs for user: " + this.userinfo.id );
                //    window.location.href='/workout/myworkout';
                } else if ( result.isDenied) {
                     Swal.fire("We will provide you with a menu-link to this video so you can re-watch it.", '', 'success');
                    this.recordQSVideoViewed(false);//false= pls provide a link in future
                }
            });
        },

        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },
    computed:{
        getData() {
             this.disclaimer_acceptedx = this.disclaimer_accepted;
        if(this.userprefsData != null){
            this.prefs_daysavailable = this.userprefsData.numdaysavailable;
            if(this.userprefsData.agreedterms_cond!= null) this.disclaimer_tick = true;
            this.prefs_exercisetype = this.userprefsData.exercise_type=='bodywt'? 'bodywttrue':'bodywtfalse';
        }

        }
    }
}
</script>


<style scoped>
.video-container {
  position: relative;
}

.arrow-image {
   position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width:60px; /* Adjust the width and height as needed */
    height: 60px;
}
.fai-yellow{
    color:yellow;
}

.heading-border{
    color:#ffffff;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
/*
  @media  (max-width: 768px)  {
    line-height: 2cap;
  } */
}
</style>
